import React, { SVGProps } from 'react'

const BackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    {...props}
  >
    <path
      fill="#3B3B3B"
      d="m12.39 5.914-1.1-1.101L6.601 9.5l4.687 4.688 1.102-1.102L8.812 9.5l3.579-3.586Z"
    />
  </svg>
)
export default BackIcon
